<template>
  <div class="shujuzhongxinSheng">
    <BaseDrawer direction="rtl" :ShowClose="true">
      <div class="wrap">
        <Title />
        <div class="jcxx">
          <Collapse title="基础信息" @changeisReceiveFair="isReceiveFair" :isReceiveFair="jcxxIsShow">
            <Tag
              v-for="(item,index) in ShuJuZhongXingYuanQujcxx"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </Collapse>
        </div>
        <div class="czzl">
          <Collapse
            title="操作指令"
            :iconUrl="require('@/assets/img/SSGJ/czzlIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="czzlIsShow"
          >
            <TagButton
              @runInHole="runInHole"
              v-for="(item,index) in czllList"
              :key="index"
              :text="item"
              :iconUrl="require('@/assets/img/SSGJ/sjzxIcon.png')"
            />
          </Collapse>
        </div>
        <div class="gjxx">
          <Collapse
            title="告警信息"
            :iconUrl="require('@/assets/img/SSGJ/gjxxIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="gjxxIsShow"
          >
            <Table :CData="ShuJuZhongXingYuanQugjxx" />
          </Collapse>
        </div>
      </div>
    </BaseDrawer>
  </div>
</template>

<script>
import Collapse from '@/components/common/communal/Collapse'
import Pagination from '@/components/common/communal/Pagination'
import Table from '@/components/common/communal/Table'
import Tag from '@/components/common/communal/Tag'
import TagButton from '@/components/common/communal/TagButton'
import BaseDrawer from '@/components/common/BaseDrawer'
import Title from '@/components/common/communal/Title'
import { mapState } from 'vuex'
export default {
  components: {
    Collapse,
    Pagination,
    Table,
    Tag,
    TagButton,
    Title,
    BaseDrawer
  },
  data() {
    return {
      ShuJuZhongXingYuanQujcxx: [
        {
          name: '名称',
          value: '分数据中心-01'
        },
        {
          name: '位置',
          value: '北京市酒仙桥松下工业园区'
        },
        {
          name: '创建时间',
          value: '2011年5月1日'
        },
        {
          name: '建筑面积',
          value: '3万平米'
        },
        {
          name: '机柜总数',
          value: '5500个'
        }
      ],
      ShuJuZhongXingYuanQugjxx: [
        { time: '2022-07-11 12:00:00', content: '数据中心发生设备故障' },
        { time: '2022-07-12 12:00:00', content: '数据中心发生服务器故障' },
        { time: '2022-07-13 12:00:00', content: '数据中心发生断电告警' },
        { time: '2022-07-14 12:00:00', content: '数据中心发生温度过高告警' },
        { time: '2022-07-15 12:00:00', content: '数据中心发生断电告警' },
        { time: '2022-07-16 12:00:00', content: '6数据中心发生温度过高告警' },
        { time: '2022-07-17 12:00:00', content: '7数据中心发生温度过高告警' },
        { time: '2022-07-18 12:00:00', content: '8数据中心发生温度过高告警' },
        { time: '2022-07-19 12:00:00', content: '9数据中心发生温度过高告警' },
        {
          time: '2022-07-11 12:00:00',
          content: '10数据中心发生温度过高告警'
        },
        {
          time: '2022-07-11 12:00:00',
          content: '11数据中心发生温度过高告警'
        },
        {
          time: '2022-07-11 12:00:00',
          content: '12数据中心发生温度过高告警'
        },
        {
          time: '2022-07-11 12:00:00',
          content: '13数据中心发生温度过高告警'
        },
        {
          time: '2022-07-11 12:00:00',
          content: '14数据中心发生温度过高告警'
        }
      ],
      jcxxIsShow: true,
      ztxxIsShow: true,
      czzlIsShow: true,
      ckllIsShow: true,
      gjxxIsShow: true,
      lssjIsShow: true,
      czllList: ['下钻至数据中心']
    }
  },
  methods: {
    runInHole(p) {
      this.$emit('runInHole', p)
    },
    isReceiveFair(p) {
      switch (p) {
        case '基础信息':
          this.jcxxIsShow = !this.jcxxIsShow
          break
        case '状态信息':
          this.ztxxIsShow = !this.ztxxIsShow
          break
        case '操作指令':
          this.czzlIsShow = !this.czzlIsShow
          break
        case '查看链路':
          this.ckllIsShow = !this.ckllIsShow
          break
        case '告警信息':
          this.gjxxIsShow = !this.gjxxIsShow
          break
        case '历史数据':
          this.lssjIsShow = !this.lssjIsShow
          break
      }
    }
  },
  computed: {
    ...mapState(['functionStatus', 'objectInfo'])
  },
  mounted() {
    this.ShuJuZhongXingYuanQujcxx[0].value = this.objectInfo.name

    switch (this.functionStatus) {
      case '默认状态':
        this.czllList = ['下钻至数据中心']
        this.czzlIsShow = true
        break
      case '对象管理':
        this.czllList = []
        this.czzlIsShow = false
        break
    }
  },
  watch: {
    functionStatus: {
      handler(val) {
        switch (val) {
          case '默认状态':
            this.czllList = ['下钻至数据中心']
            this.czzlIsShow = true
            break
          case '对象管理':
            this.czllList = []
            this.czzlIsShow = false
            break
        }
      },
      deep: true
    },
    objectInfo: {
      handler(val) {
        this.ShuJuZhongXingYuanQujcxx[0].value = val.name
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.wrap {
  width: 680px;
  height: 1720px;
  background: url('@/assets/img/WLTS/left.png') no-repeat;
}
</style>
